<div class="container">
  <div class="row mt-4 ">
    <div class="col">
      <h1><b>Verlanglijstje <span class="line">maken</span></b></h1>
    </div>
  </div>

  <div class="row">
    <div class="col-md-5 intro-section">

      <ul class="iconlist mt-4 ms-2">
        <li class="wannahaves">
          Zet wannahaves op je <a href="https://verlanglijst.online/uz49v8sj" class="background" target="_blank"
            rel="noreferrer noopener">verlanglijstje</a>
        </li>
        <li class="share">
          Deel je lijstje
        </li>
        <li class="check">
          Laat cadeautjes afstrepen
        </li>

      </ul>
      <button class="btn btn-outline-blanc shadow" routerLink="/uz49v8sj">
        Voorbeeld Verlanglijstje
      </button> <br>
      <button class="btn btn-primary btn-big shadow  mt-4 mb-4" routerLink="/auth/aanmelden">
        Gratis verlanglijstje maken
      </button> <br>

    </div>



  </div>

</div>

<section id="events-section">
  <div class="container">
    <div class="row mt-4 mb-4">
      <div class="col intro-section">
        <h2>Voor elke gelegenheid</h2>

        <div class="mt-4 mb-2">

          <button type="button" class="btnInspiration  boxShadow me-1 mb-1" routerLink="/verjaardagslijstje">
            <img src="../../../assets/iconsInApp/verjaardag3.png" alt="verlanglijstje maken voor verjaardag" width="40"
              height="40" class="mb-2"><br />
            Verjaardag
          </button>

          <button type="button" class="btnInspiration boxShadow me-1 mb-1" routerLink="/baby">
            <img src="../../../assets/iconsInApp/7BabyWhiteTicker.png" alt="verlanglijstje maken voor baby" width="40"
              height="40" class="mb-2"><br />
            Baby
          </button>

          <button type="button" class="btnInspiration  boxShadow me-1 mb-1" routerLink="/bruiloft">
            <img src="../../../assets/iconsInApp/wedding15.png" alt="verlanglijstje maken voor bruiloft" width="40"
              height="40" class="mb-2"><br />
            Bruiloft
          </button>

          <button type="button" class="btnInspiration boxShadow me-1 mb-1" routerLink="/sinterklaas">
            <img src="../../../assets/iconsInApp/sint5.png" alt="verlanglijstje maken voor sinterklaas" width="40"
              height="40" class="mb-2"><br />
            Sinterklaas
          </button>

          <button type="button" class="btnInspiration boxShadow me-1 mb-1" routerLink="/kerst">
            <img src="../../../assets/iconsInApp/christmas6.png" alt="verlanglijstje maken voor kerst" width="40"
              height="40" class="mb-2"><br />
            Kerst
          </button>

          <button type="button" class="btnInspiration boxShadow me-1 mb-1" routerLink="/meer">
            <img src="../../../assets/iconsInApp/Star.png" alt="verlanglijstje maken voor andere gelegenheden"
              height="40" class="mb-2"><br />
            en meer...
          </button>


        </div>

      </div>
    </div>


  </div>
</section>

<section id="benefits-section">
  <div class="container">
    <div class="row mb-4">
      <div class="col-md mt-4">
        <img class="img-fluid" style="border-radius: 10px;" src="../../../assets/images/happy.webp" width="550" height="387"
          alt="Voordelen van verlanglijst online">
      </div>
      <div class="col-md">
        <br />

        <h2 class="mb-2">
          Om <font class="colorVermillion"><b>blij</b></font> van te worden!
        </h2> <br />

        <ul class="like-list ms-2">
          <li>
            Modern en hip,
            helemaal anno nu.
          </li>
          <li>
            Cadeauzoeker met
            bijna alles wat je maar kunt bedenken.<br />
            Met slimme filters en zoeksuggesties,
            om inspiratie op te doen.
          </li>
          <li>
            Makkelijk en snel delen via WhatsApp, Facebook of via een link.
          </li>
          <li>
            Nooit meer dubbele cadeautjes.
          </li>
          <li>
            Fantastisch mooi op al je apparaten.
          </li>
        </ul>


      </div>
    </div>

  </div>

  <div class="centered-wrapper margin-bottom-40">

    <button class="btn btn-primary btn-big shadow mt-5 mb-5 me-md-3" type="button" routerLink="/auth/aanmelden">
      Gratis verlanglijstje maken
    </button>

    <button class="btn btn-secondary  shadow" type="button" routerLink="/catalogus">
      <img src="../../../assets/iconsInApp/Box-3.png" height="24" width="24" alt="cadeautjes toevoegen via de cadeauzoeker"
        class="mb-1">
      Cadeauzoeker
    </button>

  </div>
  <hr>

  <div class="container">
    <div class="row mb-4">

      <div class="col-md">
        <br />

        <h2 class="mb-4">
          <font class="colorVermillion"><b>Online lootjes trekken</b></font> kan ook
        </h2>

        <p>
          Lootjes trekken voor Sinterklaas, kerst of andere gelegenheden?<br>
          <a [routerLink]='["/lootjes/start"]'>Begin nu met lootjes trekken</a> bij Verlanglijst.online, dat is pas
          leuk!
        </p>
        <p>
          Heb je niet van iedereen het e-mailadres? Geen probleem!
          Je kunt lootjes ook versturen via <b>WhatsApp</b> of via een link.
        </p>
        <p>
          Deelnemers kunnen ook een <b>verlanglijstje maken</b> als ze dat willen.
        </p>




      </div>

      <div class="col-md mt-4">
        <img class="img-fluid" style="border-radius: 10px;" src="../../../assets/images/lootjestrekken700.webp"
          width="550" alt="Online lootjes trekken bij Verlanglijst.online">
      </div>

    </div>
  </div>

  <div class="centered-wrapper margin-bottom-40">

    <button class="btn btn-primary btn-big shadow mt-5 mb-5 me-md-3" type="button" routerLink="/lootjes/start">
      <img src="../../../assets/iconsInApp/play.png" height="15" width="15" alt="direct lootjes trekken" class="me-1 mb-1"> Start
      lootjes trekken
    </button>

    <button class="btn btn-secondary shadow " type="button" routerLink="/lootjestrekken">
      Lees meer over lootjes trekken
    </button>
  </div>

  @defer {
    <hr>
    <app-verlanglijst-inspire-defer></app-verlanglijst-inspire-defer>
  }


</section>

  <app-verlanglijst-other-defer></app-verlanglijst-other-defer>


